import React from 'react';
import { Section } from './Section';
export function WhyPrice() {
  return <Section tone="white" title="Why am I offering it at this price?" cta="Claim your Obesity Clinical Blueprint™" ctaNote="One-Time Payment of $27 USD · Instant Digital Access" data-id="element-290" data-mp="2d0advjulujdm">
      <div className="mx-auto max-w-2xl space-y-5 text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-291" data-mp="23zc8ax4iq3sx">
        <p data-id="element-292" data-mp="1pa69395okdl1">
          I created Obesity Clinical Blueprint™ because I believe practical clinical reference materials should be{' '}
          <strong className="text-ink" data-id="element-293" data-mp="1u26e3g0lxwoh">accessible without requiring a substantial upfront investment.</strong>
        </p>
        <p data-id="element-294" data-mp="1gbuhb3t2v9r0">
          My goal is to provide healthcare professionals with a structured collection they can use to organize their
          work, prepare consultations, and document clinical reviews.
        </p>
        <p data-id="element-295" data-mp="16e6cfl1rclv4">
          I didn't want to create another expensive educational program that requires hours of study before you can
          start using the resources. Instead, I brought together six focused volumes and five practical tools in one
          downloadable collection.
        </p>
        <p className="font-semibold text-ink" data-id="element-296" data-mp="of1ahxsx9tcg">
          You pay once and receive the edition you purchased, with no recurring subscription fees.
        </p>
      </div>
    </Section>;
}